import './css/App.css';
import {ThemeProvider} from "@mui/material/styles";
import theme from './css/appTheme'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {Navigate, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Home from "./pages/Home";
import {
    AppBar,
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, DialogTitle,
    IconButton, Link,
    Toolbar,
    Typography
} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import AccountIcon from '@mui/icons-material/AccountCircle';
import Calculator from "./pages/Calculator";
import {
    checkAuth,
    getDiffFlag, getEmployees,
    getPricePerHour, getSettingsProps, getShowCarTable, getShowClientTable, getShowComplexity,
    getVAT, getWorkOrders,
    license,
    logout,
} from "./serverREST";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import Login from "./pages/Login";
import Settings from "./pages/Settings";
import {
    setOpenLicenseEndedClicksAlert,
    setOpenDayClicksEndedAlert,
    setOpenDayClicksEndingAlert,
    setOpenLicenseEndedTimeAlert,
    setOpenLicenseEndingAlert,
    setServerIsNotRespondingAlert, setCustomAlertMessage,
} from "./redux/licenseSlice";
import {WebSocketMount} from "./WebSocketMount";

import LanguageSwitcher from "./components/LanguageSwitcher";
import {useTranslation} from "react-i18next";

function AppHeader() {
    let navigate = useNavigate();
    const {t} = useTranslation();
    return (
        <AppBar position="sticky" sx={{zIndex: 1500}}>
            <Toolbar variant="dense">
                <Typography variant="h6" component="div" sx={{mr: 2}}>
                    {t('header_text')}
                </Typography>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{mr: 2}}
                    onClick={() => {
                        navigate('/repair-times')
                    }}
                >
                    <HomeIcon/>
                </IconButton>
                <Typography flexGrow={1}/>

                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="settings"
                    // sx={{mr: 2}}
                    onClick={() => {
                        navigate('/repair-times/settings')
                    }}
                >
                    <AccountIcon/>
                </IconButton>
                <LanguageSwitcher/>
                <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ml: 1}}
                    onClick={() => {
                        navigate('/repair-times/login', {state: {fromExitButton: true}})
                    }}
                >
                    <LogoutIcon/>
                </IconButton>
            </Toolbar>
        </AppBar>
    )
}

function LicenseEndingAlert() {
    const openLicenseEndingAlert = useSelector(state => state.license.openLicenseEndingAlert)
    const count = useSelector(state => state.license.count)
    const daysLeft = useSelector(state => state.license.daysLeft)

    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(setOpenLicenseEndingAlert(false))
    };

    return (
        <Dialog
            open={openLicenseEndingAlert}
            onClose={handleClose}
        >
            <DialogTitle>
                Ваша лицензия подходит к концу
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Осталось запросов: {count}<br/>
                    Дней до окончания лицензии: {daysLeft}<br/>
                    Желаете купить новую лицензию?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button>
                    <Link href={'../purchase/tariffs'} underline={'none'} color="inherit">
                        Купить лицензию
                    </Link>
                </Button>
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function LicenseEndedClicksAlert() {
    const openLicenseEndedClicksAlert = useSelector(state => state.license.openLicenseEndedClicksAlert)
    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(setOpenLicenseEndedClicksAlert(false))
    };
    let navigate = useNavigate();
    return (
        <Dialog
            open={openLicenseEndedClicksAlert}
            onClose={handleClose}
        >
            <DialogTitle>
                Лицензия закончилась
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Вы израсходовали запросы к системе по вашему тарифному плану.
                    Для продолжения работы вам необходимо приобрести новую лицензию.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button>
                    <Link href={'../purchase/tariffs'} underline={'none'} color="inherit">
                        Купить лицензию
                    </Link>
                </Button>
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
                <Button
                    onClick={() => {
                        navigate('/repair-times/login', {state: {fromExitButton: true}})
                    }}>
                    Выход
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function DayClicksEndedAlert() {
    const isOpen = useSelector(state => state.license.openDayClicksEndedAlert);
    const isLicenseEndingAlert = useSelector(state => state.license.openLicenseEndingAlert);
    const openLicenseEndedClicksAlert = useSelector(state => state.license.openLicenseEndedClicksAlert);
    const openLicenseEndedTimeAlert = useSelector(state => state.license.openLicenseEndedTimeAlert);

    const startTimeStr = useSelector(state => state.license.dayCountTime);

    const startTime = new Date(startTimeStr);
    const endTime = new Date(startTime.getTime() + 60 * 60 * 24 * 1000);
    const endTimeStr = endTime.toLocaleDateString('ru') + " в " + endTime.toLocaleTimeString('ru');

    const hasLicenseAlert = isLicenseEndingAlert || openLicenseEndedClicksAlert || openLicenseEndedTimeAlert;

    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(setOpenDayClicksEndedAlert(false))
    };
    let navigate = useNavigate();
    return (
        <Dialog
            open={!hasLicenseAlert && isOpen}
            onClose={handleClose}
        >
            <DialogTitle>
                Закончились суточные запросы
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Количество запросов в 24-х часовом сеансе закончилось.<br/>
                    Новый сеанс начнется: {`${endTimeStr}.`}<br/>
                    При частом повторении данной ситуации, пожалуйста, обратитесь к менеджеру.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
                <Button
                    onClick={() => {
                        navigate('/repair-times/login', {state: {fromExitButton: true}})
                    }}>
                    Выход
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function DayClicksEndingAlert() {
    const isOpen = useSelector(state => state.license.openDayClicksEndingAlert);
    const isLicenseEndingAlert = useSelector(state => state.license.openLicenseEndingAlert);
    const openLicenseEndedClicksAlert = useSelector(state => state.license.openLicenseEndedClicksAlert);
    const openLicenseEndedTimeAlert = useSelector(state => state.license.openLicenseEndedTimeAlert);

    const hasLicenseAlert = isLicenseEndingAlert || openLicenseEndedClicksAlert || openLicenseEndedTimeAlert;

    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(setOpenDayClicksEndingAlert(false))
    };
    return (
        <Dialog
            open={!hasLicenseAlert && isOpen}
            onClose={handleClose}
        >
            <DialogTitle>
                Заканчиваются суточные запросы
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Количество запросов в 24-х часовом сеансе подходит к концу.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    )
}

function LicenseEndedTimeAlert() {
    const openLicenseEndedTimeAlert = useSelector(state => state.license.openLicenseEndedTimeAlert)
    const dispatch = useDispatch()

    const handleClose = () => {
        dispatch(setOpenLicenseEndedTimeAlert(false))
    };
    let navigate = useNavigate();
    return (
        <Dialog
            open={openLicenseEndedTimeAlert}
            onClose={handleClose}
        >
            <DialogTitle>
                Лицензия закончилась
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Период действия вашей лицензии истек.
                    Для продолжения работы вам необходимо приобрести новую лицензию.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button>
                    <Link href={'../purchase/tariffs'} underline={'none'} color="inherit">
                        Купить лицензию
                    </Link>
                </Button>
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
                <Button
                    onClick={() => {
                        navigate('/repair-times/login', {state: {fromExitButton: true}})
                    }}>

                    Выход
                </Button>
            </DialogActions>
        </Dialog>
    )
}
function ErrorMessageAlert(){
    const {isOpen,messageCode} = useSelector(state => state.license.errorMessage);
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setCustomAlertMessage({
            isOpen: false,
            messageCode: ''
        }));
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
        >
            <DialogTitle>
                {t('error_text')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t(messageCode)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {t('close_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
function ServerIsNotRespondingAlert() {
    const isOpen = useSelector(state => state.license.serverIsNotRespondingAlert);

    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setServerIsNotRespondingAlert(false));
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
        >
            <DialogTitle>
                {'Непредвиденная ошибка'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {`Непредвиденная ошибка. Новые данные могут быть не сохранены. Попробуйте еще раз.`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function AppContent() {
    useEffect(() => {
        license(() => {
            getPricePerHour();
            getVAT();
            getShowComplexity();
            getShowCarTable();
            getShowClientTable();
            getDiffFlag();
            getWorkOrders();
            getSettingsProps();
        });
    }, [])

    return (
        <div className={'app_main'}>
            <AppHeader/>

            <div style={{flexGrow: 1}}>
                <WebSocketMount/>
                <Routes>
                    <Route path="" element={<Home/>}/>
                    <Route path="calculator"
                           style={{height: '100%'}}
                           element={
                               <RequireAutomobile>
                                   <Calculator/>
                               </RequireAutomobile>
                           }/>
                    <Route path="settings" element={<Settings/>}/>
                </Routes>
            </div>

            <LicenseEndingAlert/>
            <LicenseEndedClicksAlert/>
            <LicenseEndedTimeAlert/>
            <ServerIsNotRespondingAlert/>
            <ErrorMessageAlert/>
            <DayClicksEndedAlert/>
            <DayClicksEndingAlert/>
        </div>
    )
}

function RequireAutomobile({children}) {
    const formFromStorage = JSON.parse(sessionStorage.getItem('form'))
    let location = useLocation();

    if (!formFromStorage) {
        return <Navigate to="/repair-times" state={{from: location}}/>;
    }

    return children;
}

function App() {

    useEffect(() => {
        checkAuth()
    }, [])

    console.log('App Version:', process.env.REACT_APP_VERSION);

    return (
        <ThemeProvider theme={theme}>
            <Routes>
                <Route path="/repair-times/login" element={<Login/>}/>
                <Route
                    path="/repair-times/*"
                    element={
                        <RequireAuth>
                            <AppContent/>
                        </RequireAuth>
                    }
                />
            </Routes>
        </ThemeProvider>
    );
}

function RequireAuth({children}) {
    let loggedIn = useSelector(state => state.lists.loggedIn);
    let location = useLocation();

    if (!loggedIn) {
        return <Navigate to="/repair-times/login" state={{from: location}}/>;
    }

    return children;
}

export default App;
